class Helpcenter {
  constructor(element) {
    this.helpcenter = element;
    this.filterToggle = element.querySelector('.helpcenter__filter-toggle');
    this.filterSelected = element.querySelector('.helpcenter__filter-selected');
    this.filterTags = element.querySelectorAll('.helpcenter__filter-tags button');
    this.items = [...element.querySelectorAll('.helpcenter__item')];

    this.filterToggle.addEventListener('click', (event) => {
      const expanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
      event.currentTarget.setAttribute('aria-expanded', !expanded);
    });

    this.filterSelected.addEventListener('click', () => {
      this.filterToggle.setAttribute('aria-expanded', true);
    });

    this.filterTags.forEach((tag) => {
      tag.addEventListener('click', () => {
        tag.parentElement.querySelector('button[disabled]').removeAttribute('disabled');
        tag.setAttribute('disabled', '');
        this.helpcenter.classList.toggle('helpcenter--filtered', tag.dataset.query);
        this.filterSelected.querySelector('span').textContent = tag.textContent;
        this.doFilter(tag);
      });
    });
  }

  doFilter(tag) {
    this.items.forEach((item) => {
      const tags = item.dataset.tags.split(',');
      item.classList.toggle('helpcenter__item--show', tags.includes(tag.dataset.query));
    });
  }
}

const init = () => {
  [...document.querySelectorAll('.js-helpcenter')].forEach((el) => new Helpcenter(el));
};

export { init };
